// src/services/campaignService.js
const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;
// const REACT_BASE_URL = process.env.REACT_APP_REDIRECT_URI;
export async function fetchRecentCampaigns() {
  const res = await fetch(`${API_BASE_URL}/directapi/recent-campaigns`);
  if (!res.ok) {
    const errText = await res.text();
    throw new Error(errText || "Failed to fetch campaigns");
  }
  return res.json();
}

export async function scheduleCampaign(payload) {
  const res = await fetch(`${API_BASE_URL}/directapi/schedule-campaign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const errText = await res.text();
    throw new Error(errText || "Failed to schedule campaign");
  }
  return res.json();
}
